import Vue from "vue";
import App from "./App.vue";
// import "./mock";
import "@/styles/global.less";
import router from "./router";
import store from "./store";
import { message } from "./utils";
import loading from "./directives/loading";
import lazy from "./directives/lazy";
import "./eventBus";

Vue.prototype.$message = message;
Vue.directive("loading", loading);
Vue.directive("lazy", lazy);

store.dispatch("setting/getSetting");

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
